import request from '@/utils/request'

export function listPayinChannels(data) {
  return request({
    url: '/api/v1/admin/payment/payin/channel/list',
    method: 'post',
    mock: false,
    data,
  })
}

export function updatePayinChannel(data) {
  return request({
    url: '/api/v1/admin/payment/payin/channel/update',
    method: 'post',
    mock: false,
    data,
  })
}

export function listPayoutChannels(data) {
  return request({
    url: '/api/v1/admin/payment/payout/channel/list',
    method: 'post',
    mock: false,
    data,
  })
}

export function updatePayoutChannel(data) {
  return request({
    url: '/api/v1/admin/payment/payout/channel/update',
    method: 'post',
    mock: false,
    data,
  })
}
